module.exports = __webpack_public_path__ + "img/1954_no.a5659d3a.svg";